module.exports = __webpack_public_path__ + "files/04befb0aeb3adb3c0c0f8a5b7532dc90.png";